import Highcharts from 'highcharts'

const PRINT_OVERRIDES: Highcharts.Options = {
  chart: {
    style: { fontSize: '12px' }
  },
  exporting: { enabled: false },
  tooltip: { enabled: false },
  legend: {
    itemStyle: { fontSize: '10px' }
  },
  xAxis: {
    labels: { style: { fontSize: '10px' } }
  },
  yAxis: [{ labels: { style: { fontSize: '10px' } } }, { labels: { style: { fontSize: '10px' } } }],
  plotOptions: {
    series: {
      animation: false,
      enableMouseTracking: false,
      states: {
        hover: { enabled: false },
        inactive: { enabled: false }
      },
      dataLabels: { style: { fontSize: '18px' } }
    },
    pie: {
      cursor: 'default'
    }
  }
}

export const withPrintOverrides = (options: Highcharts.Options, printMode?: boolean): Highcharts.Options => {
  if (!printMode) return options
  const merged = Highcharts.merge(options, PRINT_OVERRIDES) as Highcharts.Options
  // Highcharts.merge replaces arrays entirely — re-merge yAxis entries individually
  if (options.yAxis && PRINT_OVERRIDES.yAxis) {
    const baseAxes = (Array.isArray(options.yAxis) ? options.yAxis : [options.yAxis]) as Highcharts.YAxisOptions[]
    const overrideAxes = (
      Array.isArray(PRINT_OVERRIDES.yAxis) ? PRINT_OVERRIDES.yAxis : [PRINT_OVERRIDES.yAxis]
    ) as Highcharts.YAxisOptions[]
    merged.yAxis = baseAxes.map((axis, i) => Highcharts.merge(axis, overrideAxes[i] ?? overrideAxes[0]))
  }
  return merged
}
